import { useEffect } from 'react';
import { Navbar } from '@/components/Navbar';
import { Footer } from '@/components/Footer';
import { SEO } from '@/components/SEO';
import { MessageCircle } from 'lucide-react';

declare global {
  interface Window {
    fcWidget: {
      init: (config: { token: string; host: string; widgetUuid: string }) => void;
      open: () => void;
      isOpen: () => boolean;
    };
  }
}

const Support = () => {
  useEffect(() => {
    // Auto-open the chat widget when visiting support page
    const openChat = () => {
      if (window.fcWidget && typeof window.fcWidget.open === 'function') {
        window.fcWidget.open();
      }
    };

    // Try to open immediately, and retry after a delay if widget isn't ready
    const timer = setTimeout(openChat, 1500);
    
    return () => clearTimeout(timer);
  }, []);

  return (
    <div className="min-h-screen bg-background">
      <SEO 
        title="Support | EVgateway"
        description="Get help and support for EVgateway EV charging solutions. Our team is ready to assist you."
      />
      <Navbar />
      
      <main className="pt-24 pb-16">
        <div className="container mx-auto px-4">
          <div className="max-w-3xl mx-auto text-center">
            <div className="inline-flex items-center justify-center w-16 h-16 rounded-full bg-primary/10 mb-6">
              <MessageCircle className="w-8 h-8 text-primary" />
            </div>
            <h1 className="text-4xl md:text-5xl font-bold text-foreground mb-4">
              How Can We Help?
            </h1>
            <p className="text-lg text-muted-foreground mb-8">
              Our support team is available to assist you with any questions about EVgateway's EV charging solutions.
            </p>
            
            <div className="bg-card border border-border rounded-xl p-8 shadow-sm">
              <h2 className="text-xl font-semibold text-foreground mb-4">
                Live Chat Support
              </h2>
              <p className="text-muted-foreground mb-6">
                The chat widget should appear in the bottom-right corner of your screen. 
                Click on it to start a conversation with our support team.
              </p>
              <div className="flex items-center justify-center gap-2 text-sm text-muted-foreground">
                <span className="w-2 h-2 rounded-full bg-green-500 animate-pulse"></span>
                <span>Support team is online</span>
              </div>
            </div>
          </div>
        </div>
      </main>

      <Footer />
    </div>
  );
};

export default Support;
